import { render } from "./AnswerOver.vue?vue&type=template&id=b9a70df4&scoped=true"
import script from "./AnswerOver.vue?vue&type=script&lang=js"
export * from "./AnswerOver.vue?vue&type=script&lang=js"

import "./AnswerOver.vue?vue&type=style&index=0&id=b9a70df4&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a70df4"]])

export default __exports__